import React from "react";
import { useTranslation } from "react-i18next";
import { CATS, startOfWeek, startOfDay, addDays, sameDay } from "./constants";

export function MonthGrid({ anchor, events, onPickDay }) {
  const { t, i18n } = useTranslation();
  const LOC = i18n.language || "en";
  const first = new Date(anchor.getFullYear(), anchor.getMonth(), 1);
  const gridStart = startOfWeek(first);
  const cells = Array.from({ length: 42 }, (_, i) => addDays(gridStart, i));
  const weekdayNames = Array.from({ length: 7 }, (_, i) => addDays(gridStart, i).toLocaleDateString(LOC, { weekday: "short" }));
  return (
    <div className="flex flex-col overflow-y-auto" style={{ maxHeight: "calc(100vh - 20rem)", minHeight: 480 }}>
      <div className="grid grid-cols-7 border-b border-slate-200 bg-white sticky top-0 z-10">
        {weekdayNames.map((w) => <div key={w} className="py-2 text-center text-[11px] uppercase tracking-wide text-slate-400 border-r border-slate-100 last:border-r-0">{w}</div>)}
      </div>
      <div className="grid grid-cols-7 flex-1">
        {cells.map((day, i) => {
          const inMonth = day.getMonth() === anchor.getMonth();
          const isToday = sameDay(day, new Date());
          const dayEvents = events.filter((ev) => ev.start < addDays(startOfDay(day), 1) && ev.end > startOfDay(day)).sort((a, b) => a.start - b.start);
          return (
            <button key={day.toISOString()} data-testid={`month-cell-${i}`} onClick={() => onPickDay(day)}
              className={`min-h-[92px] border-b border-r border-slate-100 p-1.5 text-left align-top hover:bg-slate-50 transition-colors ${inMonth ? "bg-white" : "bg-slate-50/50"}`}>
              <div className={`text-xs font-semibold w-6 h-6 grid place-items-center rounded-full mb-1 ${isToday ? "bg-indigo-600 text-white" : inMonth ? "text-slate-700" : "text-slate-300"}`}>{day.getDate()}</div>
              <div className="space-y-1">
                {dayEvents.slice(0, 3).map((ev) => {
                  const cat = CATS[ev.category];
                  return <div key={ev.id} className={`flex items-center gap-1 text-[10px] rounded px-1 py-0.5 truncate ${cat.block}`}><span className="truncate">{ev.title}</span></div>;
                })}
                {dayEvents.length > 3 && <div className="text-[10px] text-slate-400 pl-1">{t("cal.more", { count: dayEvents.length - 3 })}</div>}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
